import { render, staticRenderFns } from "./offstandardProductAddImg.vue?vue&type=template&id=c7520930&scoped=true"
import script from "./offstandardProductAddImg.vue?vue&type=script&lang=js"
export * from "./offstandardProductAddImg.vue?vue&type=script&lang=js"
import style0 from "./offstandardProductAddImg.vue?vue&type=style&index=0&id=c7520930&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7520930",
  null
  
)

export default component.exports